module.exports = __webpack_public_path__ + "img/forte6.59d5f5dd.jpeg";